// Exportación a Excel de pedidos de venta, compartida por la lista y el cockpit.
//
// La lista exporta lo que tenga filtrado; el cockpit, el pedido que se está
// mirando. Es la MISMA exportación —mismas hojas, columnas, traducciones y
// formato—: sólo cambia el conjunto de pedidos que entra. Tener dos
// implementaciones era la vía rápida para que un día dejaran de cuadrar.
import type { TFunction } from 'i18next'
import { pedidosVentasApi } from '@/services/api'
import { exportPedidosVentasExcel } from './exportPedidosVentasExcel'
import type { AlbaranLinea, CargaLinea, PedidoVentaLinea, PedidoVentaRow } from '@/types'

interface Opciones {
  isEmpresaAll: boolean
  t: TFunction
  fmtArt: (code?: string) => string
}

/** Descarga el libro con los pedidos dados y todo su desglose.
 *
 *  Líneas, cargas y albaranes se piden en bloque: son las tres consultas que
 *  hacen que el libro se parezca a la pantalla, y son independientes entre sí. */
export async function exportarPedidosVenta(
  pedidos: PedidoVentaRow[],
  { isEmpresaAll, t, fmtArt }: Opciones,
): Promise<void> {
  if (pedidos.length === 0) return

  // Las filas del overlay todavía no tienen líneas en Fabric: van al Excel sólo
  // como cabecera, sin desglose.
  const ids = [...new Set(pedidos.filter(p => !p.pendienteSync).map(p => p.salesid))]

  const [lineasRes, cargasRes, albaranesRes] = ids.length
    ? await Promise.all([
        pedidosVentasApi.getLineasBulk(ids),
        pedidosVentasApi.getCargasBulk(ids),
        pedidosVentasApi.getAlbaranesBulk(ids),
      ])
    : [{ data: [] }, { data: [] }, { data: [] }]

  await exportPedidosVentasExcel(
    {
      pedidos,
      lineas: (lineasRes.data ?? []) as PedidoVentaLinea[],
      cargas: (cargasRes.data ?? []) as CargaLinea[],
      albaranes: (albaranesRes.data ?? []) as AlbaranLinea[],
    },
    { isEmpresaAll, t, fmtArt },
  )
}
